/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleBigQueryGa4PseudonymousUsersReportTotalsData
 */
export interface GoogleBigQueryGa4PseudonymousUsersReportTotalsData {
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4PseudonymousUsersReportTotalsData
     */
    changedIdentifierDays?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4PseudonymousUsersReportTotalsData
     */
    activeIdentifierDays?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4PseudonymousUsersReportTotalsData
     */
    firstTouchPseudonymousIdentifiers?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4PseudonymousUsersReportTotalsData
     */
    firstPurchasePseudonymousIdentifiers?: number;
}

/**
 * Check if a given object implements the GoogleBigQueryGa4PseudonymousUsersReportTotalsData interface.
 */
export function instanceOfGoogleBigQueryGa4PseudonymousUsersReportTotalsData(value: object): value is GoogleBigQueryGa4PseudonymousUsersReportTotalsData {
    return true;
}

export function GoogleBigQueryGa4PseudonymousUsersReportTotalsDataFromJSON(json: any): GoogleBigQueryGa4PseudonymousUsersReportTotalsData {
    return GoogleBigQueryGa4PseudonymousUsersReportTotalsDataFromJSONTyped(json, false);
}

export function GoogleBigQueryGa4PseudonymousUsersReportTotalsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleBigQueryGa4PseudonymousUsersReportTotalsData {
    if (json == null) {
        return json;
    }
    return {
        
        'changedIdentifierDays': json['changedIdentifierDays'] == null ? undefined : json['changedIdentifierDays'],
        'activeIdentifierDays': json['activeIdentifierDays'] == null ? undefined : json['activeIdentifierDays'],
        'firstTouchPseudonymousIdentifiers': json['firstTouchPseudonymousIdentifiers'] == null ? undefined : json['firstTouchPseudonymousIdentifiers'],
        'firstPurchasePseudonymousIdentifiers': json['firstPurchasePseudonymousIdentifiers'] == null ? undefined : json['firstPurchasePseudonymousIdentifiers'],
    };
}

export function GoogleBigQueryGa4PseudonymousUsersReportTotalsDataToJSON(json: any): GoogleBigQueryGa4PseudonymousUsersReportTotalsData {
    return GoogleBigQueryGa4PseudonymousUsersReportTotalsDataToJSONTyped(json, false);
}

export function GoogleBigQueryGa4PseudonymousUsersReportTotalsDataToJSONTyped(value?: GoogleBigQueryGa4PseudonymousUsersReportTotalsData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'changedIdentifierDays': value['changedIdentifierDays'],
        'activeIdentifierDays': value['activeIdentifierDays'],
        'firstTouchPseudonymousIdentifiers': value['firstTouchPseudonymousIdentifiers'],
        'firstPurchasePseudonymousIdentifiers': value['firstPurchasePseudonymousIdentifiers'],
    };
}

